import React from "react"
import { Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"

import { BigHeader, Footer } from "core/components"
import { UserLoginForm } from "users"

const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: 570,
    margin: "0 auto",

    padding: theme.spacing(2),

    [theme.breakpoints.up("md")]: {
      padding: 0,
    },
  },
  title: theme.presets.title,
}))

function ScreensUserLogin() {
  const classes = useStyles()
  return (
    <React.Fragment>
      <BigHeader isLoggedIn={false} />
      <div className={classes.content}>
        <Typography variant="h1" align="center" className={classes.title}>
          ВХОД НА САЙТ
        </Typography>
        <UserLoginForm />
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default ScreensUserLogin
